import { ActivityEntityName } from '../../../../entities';
import { MergeDataset, MergeSource } from '../../decorators';
import { AccountMergeData, AccountMergeSchema, ContactFullMergeData, ContactFullMergeSchema, } from '../data';

@MergeDataset({
    entity: ActivityEntityName.Account,
})
export class AccountMergeDataset {
    @MergeSource({
        schema: AccountMergeSchema,
        ignoreFields: ["taxId"]
    })
    account: AccountMergeData;

    @MergeSource({
        schema: ContactFullMergeSchema,
        ignoreCustomFields: true,
        ignoreFields: ["jobTitle"]
    })
    primaryContact: ContactFullMergeData;
}